const resource = "/api/operation/products"

let service = {
  getAll(filters = {}, page) {
    if (page) {
      filters.page = page;
      filters.paginated = true;
    }

    return axios.get(resource, {params: filters});
  },
  insert(data) {
    return axios.post(resource, data);
  },
  update(id, data) {
    return axios.put(resource + "/" + id, data);
  },
  remove(id) {
    return axios.delete(resource + "/" + id);
  }
}
export default service


// WEBPACK FOOTER //
// ./resources/assets/js/api/produtos.js